// 一级部门
export const DEPARTMENT_LIST_GET_REQUEST = 'DEPARTMENT_LIST_GET_REQUEST';
export const DEPARTMENT_LIST_GET_REQUEST_SUCCESS = 'DEPARTMENT_LIST_GET_REQUEST_SUCCESS';

// 招聘负责人
export const HR_LIST_GET_REQUEST = 'HR_LIST_GET_REQUEST';
export const HR_LIST_GET_REQUEST_SUCCESS = 'HR_LIST_GET_REQUEST_SUCCESS';

// 招聘负责人
export const PUBLISH_STATE_LIST_GET_REQUEST = 'PUBLISH_STATE_LIST_GET_REQUEST';
export const PUBLISH_STATE_LIST_GET_REQUEST_SUCCESS = 'PUBLISH_STATE_LIST_GET_REQUEST_SUCCESS';

// 需求提交人
export const JD_CREATE_STATE_LIST_GET_REQUEST = 'JD_CREATE_STATE_LIST_GET_REQUEST';
export const JD_CREATE_STATE_LIST_GET_REQUEST_SUCCESS = 'JD_CREATE_STATE_LIST_GET_REQUEST_SUCCESS';

// 流程状态
export const JD_PUBLISH_STATUS_LIST_GET_REQUEST = 'JD_PUBLISH_STATUS_LIST_GET_REQUEST';
export const JD_PUBLISH_STATUS_LIST_GET_REQUEST_SUCCESS = 'JD_PUBLISH_STATUS_LIST_GET_REQUEST_SUCCESS';

// 筛选状态
export const FILTER_STATUS_LIST_GET_REQUEST = 'FILTER_STATUS_LIST_GET_REQUEST';
export const FILTER_STATUS_LIST_GET_REQUEST_SUCCESS = 'FILTER_STATUS_LIST_GET_REQUEST_SUCCESS';

// 职位名称
export const JOB_LIST_GET_REQUEST = 'JOB_LIST_GET_REQUEST';
export const JOB_LIST_GET_REQUEST_SUCCESS = 'JOB_LIST_GET_REQUEST_SUCCESS';

// 人才库搜索职位名称
export const TALENT_JOB_LIST_GET_REQUEST = 'TALENT_JOB_LIST_GET_REQUEST';
export const TALENT_JOB_LIST_GET_REQUEST_SUCCESS = 'TALENT_JOB_LIST_GET_REQUEST_SUCCESS';

// 面试官
export const USER_LIST_GET_REQUEST = 'USER_LIST_GET_REQUEST';
export const USER_LIST_GET_REQUEST_SUCCESS = 'USER_LIST_GET_REQUEST_SUCCESS';

// 获取面试形式，面试类型，签到状态
export const INTERVIEW_TYPE_WAY_SIGNSTATUS_LIST_GET_REQUEST = 'INTERVIEW_TYPE_WAY_SIGNSTATUS_LIST_GET_REQUEST';
export const INTERVIEW_TYPE_WAY_SIGNSTATUS_LIST_GET_REQUEST_SUCCESS = 'INTERVIEW_TYPE_WAY_SIGNSTATUS_LIST_GET_REQUEST_SUCCESS';

// 获取应聘者数据分析map 阶段-状态/申请渠道类型/申请渠道名称
export const APPLICANT_MAP_GET_REQUEST = 'APPLICANT_MAP_GET_REQUEST';
export const APPLICANT_MAP_GET_REQUEST_SUCCESS = 'APPLICANT_MAP_GET_REQUEST_SUCCESS';

// 内部推荐分析/内推淘汰数据分析 淘汰类型和渠道
export const WEEDOUT_MAP_GET_REQUEST = 'WEEDOUT_MAP_GET_REQUEST';
export const WEEDOUT_MAP_GET_REQUEST_SUCCESS = 'WEEDOUT_MAP_GET_REQUEST_SUCCESS';

// 获取职位状态
export const POST_STATUS_GET_REQUEST = 'POST_STATUS_GET_REQUEST';
export const POST_STATUS_GET_REQUEST_SUCCESS = 'POST_STATUS_GET_REQUEST_SUCCESS';


// Common POST Request
export const POST_REQUEST = 'POST_REQUEST';
export const POST_REQUEST_SUCCESS = 'POST_REQUEST_SUCCESS';
export const POST_REQUEST_FAILURE = 'POST_REQUEST_FAILURE';

// Common GET Request
export const GET_REQUEST = 'GET_REQUEST';
export const GET_REQUEST_SUCCESS = 'GET_REQUEST_SUCCESS';
export const GET_REQUEST_FAILURE = 'GET_REQUEST_FAILURE';

// 需求部门
export const NEED_DEPT_LIST_GET_REQUEST = 'NEED_DEPT_LIST_GET_REQUEST';
export const NEED_DEPT_LIST_GET_REQUEST_SUCCESS = 'NEED_DEPT_LIST_GET_REQUEST_SUCCESS'